import Popover from '@material-ui/core/Popover';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { ReactComponent as ExportIcon } from 'assets/icons/Export.svg';
import React, { useEffect, useState } from 'react';
import { ReactComponent as Edit } from '../assets/icons/EditClass.svg';
import { ReactComponent as Delete } from '../assets/icons/Group 237992.svg';
import { ReactComponent as Archive } from '../assets/icons/Layer 38.svg';

import './style.scss';

export default function ClassDrawerPopOver({
  onEditClick,
  onArchiveClick,
  onClassDeleteClick,
  action,
  MoreVert,
  activeUesr,
  styles,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div>
      <div>
        <MoreHorizIcon
          color="primary"
          className="more__hor"
          onClick={handleClick}
        />
      </div>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{
          color: 'red',
        }}
      >
        <div
          className="popover-drawer-class"
          style={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between',
            alignItems: 'flex-start',
            padding: '10px 0',
            width: '111px',
            minHeight: '142px',
            borderRadius: '6px',
            gap: '0.5rem',
            ...styles,
          }}
        >
         
          <div
            onClick={() => {
              onEditClick();
              setAnchorEl(null);
            }}
            className="schoolDrawer__action"
          >
            <Edit className="mr-3" />
            Edit
          </div>
          {onArchiveClick ? (
            <div
              className="schoolDrawer__action"
              onClick={() => {
                onArchiveClick();
                setAnchorEl(null);
              }}
            >
              <Archive className="mr-3" /> Archive
            </div>
          ) : (
            ''
          )}

          <div
            className="schoolDrawer__action"
            onClick={() => {
              onClassDeleteClick();
              setAnchorEl(null);
            }}
          >
            <Delete className="mr-3" />
            <span className="text-danger">Delete</span>
          </div>
        </div>
      </Popover>
    </div>
  );
}
